<template>
  <div>
    
    <div style="margin-top: 50px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div 
            style="margin-top: 50px; display: flex; 
            flex-direction: column; 
            width: 400px; 
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
            padding: 20px;
            justify-content: center; align-items: center;">

                <img alt="Easy Tailor App Logo" src="../../../assets/eta.png" style="width: 150px; ">

                <div style="margin-top: 50px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">First Name</span>
                    <el-input @focus="$event.target.select()"
                        size="small"
                        id="firstName"
                        v-model.trim="$store.state.signup.props.first_name">
                    </el-input>
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Last Name</span>
                    <el-input @focus="$event.target.select()"
                        size="small"
                        id="lastName"
                        v-model.trim="$store.state.signup.props.last_name">
                    </el-input>
                </div>
                
                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Brand Name</span>
                    <el-input @focus="$event.target.select()"
                        size="small"
                        id="brandName"
                        v-model="$store.state.signup.props.brand_name">
                    </el-input>
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Country</span>
                    <el-select 
                    size="small"
                    default-first-option
                    id="countryId" v-model="$store.state.signup.props.country_id" filterable style="width: 100%;">
                    <el-option
                        v-for="(data, index) in $store.getters.getCountryList"
                        :key="index"
                        :label="data.country_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.country_icon"></span>
                        <span style="float: left;">{{ data.country_name }}</span>
                    </el-option>
                </el-select>
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Email Address</span>
                    <el-input @focus="$event.target.select()"
                        size="small"
                        id="emailAddress"
                        v-model.trim="$store.state.signup.props.email_address">
                    </el-input>
                </div>

                <!--<div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Tailoring Category</span>
                    <el-select 
                    size="small"
                    default-first-option
                    id="countryId" 
                    v-model="$store.state.signup.props.tailoring_category" filterable style="width: 100%;">
                    <el-option
                        v-for="(data, index) in tailoring_category"
                        :key="index"
                        :label="data.name"
                        :value="data.id">
                        <span style="float: left;">{{ data.name }}</span>
                    </el-option>
                </el-select>
                </div>-->
                
                <div style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: space-between; align-items: space-between;">
                    <el-button :loading="$store.getters.getLoadingState" @click="checkIfTenantExists" type="primary" size="small">Register Account</el-button>
                    <el-link @click="$router.push('/login')">Already Have Account?</el-link>                        
                </div>

        </div>
    </div>
        
  </div>
</template>

<script>
export default {
    data() {
        return {
            processing: false,
            tailoring_category: [
                {id: 0, name: 'Western Wear'},
                {id: 1, name: 'Western Wear - Outsourcing'},
                {id: 2, name: 'Indo-Western Wear'},
                {id: 3, name: 'Middle East Ethnic Wear'}
            ]
        }
    },
    computed: {
        isProcessing() {
            return this.processing
        }
    },
    methods: {
        async checkIfTenantExists() {

            if(this.$store.state.signup.props.first_name.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'First name is missing', type: 'Error'})    
                document.getElementById('firstName').focus()
                return
            } else if(this.$store.state.signup.props.last_name.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Last name is missing', type: 'Error'})    
                document.getElementById('lastName').focus()
                return
            } else if(this.$store.state.signup.props.brand_name.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Brand name is missing', type: 'Error'})    
                document.getElementById('brandName').focus()
                return
            } else if(this.$store.state.signup.props.country_id === null) {
                this.$store.commit('displayMessageAlert', {message: 'Please mention you country of origin', type: 'Error'})    
                document.getElementById('countryId').focus()
                return
            } else if(this.$store.state.signup.props.email_address === null) {
                this.$store.commit('displayMessageAlert', {message: 'Email address is missing', type: 'Error'})    
                document.getElementById('emailAddress').focus()
                return
            } else if(this.invalidEmailAddress(this.$store.state.signup.props.email_address)) {
                this.$store.commit('displayMessageAlert', {message: 'Invalid Email Address', type: 'Error'})    
                document.getElementById('emailAddress').focus()
                return
            }

            this.processing = true

            let payload = this.$store.getters.getSignupProps
            await this.$store.dispatch('checkIfTenantExists', payload)

            setTimeout(() => {
                this.processing = false
            }, 1000);
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Session/Signup/Index.vue